// [PURPOSE]: THEME PICKER INFRASTRUCTURE — registry of available themes.
// [DESIGN-THEME-SUBSTRATE 2026-07-04]
//
// [WHY]: The user explicitly REJECTED shipping any pre-authored theme content
//   in this arc. This file ships the REGISTRY ONLY — the picker (SettingsPanel)
//   reads it to render options; AppearanceController (already wired, lines
//   37-45) reads settings.theme and sets/removes data-theme on <html>.
//   Zero [data-theme=x] visual rule blocks exist yet — src/themes.css only
//   documents the landing-zone contract below.
//
// [BRING-BACK CONTRACT — how a new theme gets added later]:
//   A new theme = exactly two additive edits, nothing more:
//     (a) append ONE `[data-theme="<id>"] { ... }` block to src/themes.css
//         (rules scoped under the attribute selector — never bare selectors
//         that would leak into the default look);
//     (b) append ONE `{ id: '<id>', label: '<Human Label>' }` entry to the
//         AVAILABLE_THEMES array below.
//   Both edits are additive — neither ever touches an existing entry/block.
//
// [DEFAULT ENTRY — id: '']: The empty-string id is NOT a placeholder to be
//   replaced — it is the permanent "no theme" entry. AppearanceController's
//   `if (settings.theme) { setAttribute } else { removeAttribute }` branch
//   means id '' always resolves to "no data-theme attribute on <html>" —
//   i.e. the current default dark look, completely undisturbed.
//
// [ADDITIVE / REVERSIBLE]: The default look is NEVER modified by adding a
//   theme. Selecting any theme is instantly reversible by picking Default
//   again — no data is destroyed, no CSS is overwritten, only the
//   data-theme attribute value changes.

/**
 * @typedef {Object} ThemeDescriptor
 * @property {string} id    - Stable identifier. '' = default (no data-theme attr).
 * @property {string} label - Human-readable name shown in the theme picker <select>.
 */

/** @type {ThemeDescriptor[]} */
export const AVAILABLE_THEMES = [
  { id: '', label: 'Default (dark)' }
];
